<script setup lang="ts">

</script>

<template>
  <div>
    <AppFooter :logo-src="require('../images/footer-logo.png')"></AppFooter>
  </div>
</template>

<style scoped lang="scss">
@import '../vars.scss';

:deep(.footer-wrapper) {
  margin-top: 0;
  font-family: 'Pretendard', sans-serif;
  color: $white;
  background-color: $primary-color;

  .router-link, .desc {
    color: $white;
  }

  .sns-logo {
    filter: brightness(0) invert(1);
  }

  .sns-logo.hover {
    filter: unset;
  }
}

.footer-content {
  font-size: 14px;
  color: $white;
  background: $primary-color;
}

.footer-logo {
  max-width: 100%;
  height: auto;
}

.footer-nav {
  .footer-link {
    font-weight: 400;
    text-decoration: none;
    color: $white;
    transition: opacity 0.3s ease;

    &:hover {
      color: $white;
      opacity: 0.8;
    }
  }
}

.social-icons {
  .social-link {
    font-size: 18px;
    color: $white;
    transition: opacity 0.3s ease;

    &:hover {
      color: $white;
      opacity: 0.8;
    }
  }
}

.footer-bottom {
  .address-text {
    margin: 0;
    font-size: 12px;
    line-height: 1.4;
    opacity: 0.9;
  }
}

@media (max-width: 768px) {
  .footer-content {
    text-align: center;
  }

  .social-icons {
    justify-content: center !important;
  }

  .footer-nav {
    justify-content: center;
  }
}
</style>
